import { Helmet } from 'react-helmet'

import { schemaOrgWebPage } from '../../utils/ld'

import Facebook from './Facebook'
import { SEOProps } from './interface'
import Twitter from './Twitter'

function toTitle(title?: string, defaultTitle?: string) {
  if (defaultTitle) {
    return title ? `${title} : ${defaultTitle}` : defaultTitle
  }
  return title || ''
}

function SEO({
  title,
  // pathname,
  url,
  defaultTitle,
  defaultDescription,
  description,
  // siteUrl,
  defaultBanner,
  imageAlt,
  language,
  twitter,
  facebook,
  buildTime,
  canonical,
  disableDefaultDescription,
}: SEOProps) {
  const seo = {
    title: toTitle(title, defaultTitle),
    description: disableDefaultDescription ? description : description || defaultDescription,
    image: `${defaultBanner}`,
    imageAlt,
    url: url || '',
    canonical,
  }

  return (
    <>
      <Helmet title={seo.title || ''}>
        <html lang={language || 'ja'} />
        {seo.description && <meta name="description" content={seo.description} />}
        <meta name="image" content={seo.image} />
        {seo.canonical && <link rel="canonical" href={seo.canonical} />}
        {/* Insert schema.org data conditionally (webpage/article) + everytime (breadcrumbs) */}
        <script type="application/ld+json">
          {JSON.stringify(
            schemaOrgWebPage(url, language, defaultDescription, defaultTitle, buildTime, seo.image)
          )}
        </script>
      </Helmet>
      <Facebook
        description={seo.description || ''}
        image={seo.image}
        title={seo.title || ''}
        type={'website'}
        url={seo.url}
        imageAlt={seo.imageAlt}
        name={facebook || ''}
      />
      <Twitter
        title={seo.title || ''}
        image={seo.image}
        description={seo.description || ''}
        username={twitter || ''}
      />
    </>
  )
}
export default SEO
